import { render, staticRenderFns } from "./livraison.vue?vue&type=template&id=1867b2b2&"
import script from "./livraison.vue?vue&type=script&lang=js&"
export * from "./livraison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports